import { Deserializable } from "./deserializable.model";

export interface Carteira {
  id?: number;
  id_empresa: string;
  id_paciente: string;
  nome_paciente: string;
  criado_em: Date;
}

export interface Procedimentos {
  id_proc: string;
  categoria: string;
  nomeProced: string;
  valorFinal: string;
  valorRepasse: string;
}

export class Consultor implements Deserializable {
  public _id?: number;
  public nome_fantasia?: string;
  public cnpj?: string;
  public email?: string;
  public cidade?: string;
  public estado?: string;
  public role?: string[];
  public categoria?: string[];
  public telefone?: string;
  public celular?: string;
  public endereco?: string;
  public carteira?: Carteira[];
  public createdAt: Date;
  public updatedAt: Date;
  public procedimentos?: Procedimentos[]; // Alterado
  public banco: string;
  public agencia: string;
  public conta: string;
  public logo: any;
  public password: string;
  public ativa: boolean;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
